import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getHubHomeRequest } from '../../actionCreators/homeHubActions';


import HomeComponent from '../../components/Home';

const Home = (props) => <HomeComponent {...props} />;

const HomeContainer = (props) => {
  const state = useSelector((state) => ({
    featureFlags: state.featureFlags || {},
    homeHub: state.homeHub.homeHub || []
  }));

  const dispatch = useDispatch();

  const actions = {
    getHomeHub: (payload) => dispatch(getHubHomeRequest(payload)),
  };

  return <Home {...props} {...state} {...actions} />;
};

export default HomeContainer;
